const PREFIX = process.env.REACT_APP_BACKEND_URL + '/statistics';

// API Handler for annotator module of backend server providing annototar
// related methods
export const STATISTICS_API = {
  getEventByClass: async (userToken, userId, timeline) => {
    const response = await fetch(`${PREFIX}/getEventsByClass`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${userToken}`,
      },
      body: JSON.stringify({
        userId: userId,
        timeline: timeline,
      }),
    });
    const data = await response.json();
    return data;
  },
};
